<template>
  <div>
    <card-seplag
      titulo="Anexe/Envie o documento gerado na Declaração Anual de Pessoa Física do corrente ano, contendo o quadro de Identificação, Dependentes e Bens e Direitos."
    >
      <Rotulo nome="" cols="12" class="rotulo">
        <div class="cardButtonFile">
          <DataTable
            :value="listaArquivoIR"
            class="p-datatable-responsive-demo p-datatable-gridlines"
            v-if="listaArquivoIR.length > 0"
            :rowClass="rowClass"
          >
            <Column
              field="arquivo.tipoExtensaoArquivo"
              header="Extensão"
              headerStyle="width: 8rem"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Extensão:</span>
                {{ slotProps.data.arquivo.tipoExtensaoArquivo }}
              </template>
            </Column>

            <Column
              field="arquivo.descArquivo"
              header="Arquivo"
              bodyClass="columnAlign"
            >
              <template #body="slotProps">
                <span class="p-column-title">Arquivo:</span>
                <span>{{ slotProps.data.arquivo.descArquivo }}</span>
              </template>
            </Column>

            <Column
              headerStyle="width: 8em"
              bodyClass="columnAlign"
              header="Ação"
            >
              <template #body="slotProps">
                <Button
                  type="button"
                  icon="pi pi-print"
                  @click="download(slotProps.data.arquivo.idenArquivo)"
                  class="p-button-raised"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </Rotulo>

      <div class="p-col-12">
        <div class="avisos">
          <p>Apenas arquivos PDF de no máximo 3mb cada.</p>
        </div>
      </div>

      <div class="p-col-12" v-if="formData.descJustRetificacao">
        <div class="cardJustificativaRetificacao">
          <p class="headerJustificativaRetificacao">
            <strong>Justificativa da Retificação</strong>
          </p>
          <p class="descJustificativaRetificacao">
            {{ formData.descJustRetificacao }}
          </p>
        </div>
      </div>

      <div class="p-col p-md-4">
        <Button
          label="Voltar"
          icon="pi pi-arrow-left"
          class="p-button-raised p-button-rounded p-button-outlined"
          @click="voltar()"
        />
      </div>
    </card-seplag>
    <CardExibirPDF
      :tamanhoTela="'85,vw'"
      :alturaTela="'120,vh'"
      :pdfElement="dadosRelatorioBase64"
      v-model="isExibirPDF"
      :tituloTela="tituloPDF"
      v-if="isExibirPDF"
    />
  </div>
</template>

<script>
import CardSeplag from "@/template/CardSeplag.vue";
import Rotulo from "@/template/RotuloSeplag.vue";
import { baseApiUrl } from "@/config/global";
import CardExibirPDF from "@/template/CardExibirPDF";

export default {
  name: "declaracaoArqFederal",
  components: { CardSeplag, Rotulo, CardExibirPDF },
  props: {
    mode: {
      type: String,
      require: true,
    },
    pFormData: {
      type: Object,
      require: true,
    },
    isPermitirEditar: {
      type: Boolean,
      require: false,
    },
  },
  data: function () {
    return {
      dialogConfirmacao: false,
      dialogConfirmacaoExclusao: false,
      listaArquivoIR: [],
      listaArquivoRecibo: [],
      dadosRelatorioBase64: "",
      isExibirPDF: false,
      tituloPDF: " ",
      tituloAlterarArquivo: "",
      isShowDialogAlterarArquivo: false,
      formData: this.pFormData,
      changeArquivoObj: null,
      idenContaAcesso: 0,
      changeFileLabel: "",
      permiteExecutarAcao: this.pFormData.tipoDeclaracao != "NAO_INFORMADO",
    };
  },
  methods: {
    carregarDados() {
      this.formData = { ...this.pFormData };
      this.listaArquivoIR = this.formData.arquivosDeclaracao;
      this.listaArquivoIR = this.listaArquivoIR.map((item) => {
        let aux = { ...item };
        if (aux.flagFrontAcao == "VALIDADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (APROVADO)`;
        } else if (aux.flagFrontAcao == "RECUSADO") {
          aux.arquivo.descArquivo = `${aux.arquivo.descArquivo} (RECUSADO - ${
            aux.listaRejeicaoArquivo
              ? aux.listaRejeicaoArquivo[0].motivoRejeicao.descMotivoRejeicao
              : ""
          })`;
        }
        return aux;
      });

      this.idenContaAcesso = this.$store.getters.getUser.contaAcesso.id;
    },
    download(idenArquivoDecaracaoBem) {
      this.$http
        .get(
          `${baseApiUrl}/arquivodeclaracaobens/download/base64/${idenArquivoDecaracaoBem}`
        )
        .then((res) => {
          this.dadosRelatorioBase64 = res.data;
          this.isExibirPDF = true;
        });
    },
    rowClass(data) {
      return data.flagFrontAcao == "VALIDADO"
        ? "arquivo-aceito"
        : data.flagFrontAcao == "RECUSADO"
        ? "arquivo-recusado"
        : null;
    },

    voltar() {
      this.$router.push({
        name: "inicio",
      });
    },
  },
  mounted() {
    this.carregarDados();
  },
};
</script>

<style lang="scss" scoped >
.texto-centro {
  text-align: center;
}

.arquivo-federal-container {
  margin: auto auto;
}

.avisos {
  text-align: center;
  background-color: rgb(231, 232, 125); /* Yellow */
  color: #000000;
  border-radius: 12px;
  font-size: 1.142rem;
  font-weight: bold;
  // width: 50vw;
}

// @media screen and (min-width: 100rem){
//     .arquivo-federal-container{
//         margin: auto 20rem;
//     }
// }

.rotulo {
  margin: 1rem auto;
}

.columnAlign {
  text-align: center;
}

.p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

@media screen and (max-width: 60em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-row {
        display: flex;
        flex-direction: column;
      }
      .p-datatable-tbody > tr > td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
          text-align: center !important;
          display: flex !important;

          & button {
            width: 100%;
          }
        }
      }
    }
  }
}

.icon-arraste {
  font-size: 2rem;
  margin: 1rem 1rem;
}

.display-flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>


<style>
.arquivo-aceito {
  background-color: #6cb358 !important;
}

.arquivo-aceito td,
.arquivo-recusado td {
  color: #191010;
  font-size: 1.1rem;
  font-weight: 500;
}

.arquivo-recusado {
  background-color: #ea5d5d !important;
}
.descJustificativaRetificacao {
  margin-top: 10px;
}
.cardJustificativaRetificacao {
  border: 1px solid #d5d5d5;
  padding: 15px;
  font-size: 15px;
}
.headerJustificativaRetificacao {
  border-bottom: 1px solid #d5d5d5;
  font-size: large;
}
</style>